import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import _ from 'lodash';
import config from '../../../../app/config';
import {UtilsMomentJS} from '../../../../store/utilsMoment';
import {useStylesECDS} from './ecdsStyle';
import {AgyleTable, createAgyleTableColumn} from '../../../../components/table/AgyleTable';
import InformationBox from '../../../../components/other/informationBox';

const COLUMNS_V3 = [
    createAgyleTableColumn('no', 'No.', 1, null, 'count', 'notSort', 'medium', 'center', true, false, null, null, null),
    createAgyleTableColumn('treat', 'Treatment', 2, 'EmergencyCareProcedure_SnomedCt', 'dict', '', 'medium', 'left', true, false, null, null, null),
    createAgyleTableColumn('date', 'Procedure Date', 3, 'date', 'string', '', 'medium', 'left', true, true, null, null, null),
    createAgyleTableColumn('time', 'Procedure Time', 4, 'time', 'string', '', 'medium', 'left', true, false, null, null, null),
];

const COLUMNS_V4 = [
    createAgyleTableColumn('no', 'No.', 1, null, 'count', 'notSort', 'medium', 'center', true, false, null, null, null),
    createAgyleTableColumn('treat', 'Treatment', 2, 'EmergencyCareProcedure_SnomedCt', 'dict', '', 'medium', 'left', true, false, null, null, null),
    createAgyleTableColumn('timestamp', 'Procedure Timestamp', 3, 'timestamp', 'date', '', 'medium', 'left', true, true, null, null, null),
];

const Treatments = (props) => {
    const {t} = useTranslation();
    const classes = useStylesECDS();
    const {version} = props;

    // Multi Entry list
    const [list, setList] = useState([]);

    const setDataDictionary = () => {
        let formattedList = _.cloneDeep(list);
        for (const element of formattedList) {
            element.EmergencyCareProcedure_SnomedCt = element.EmergencyCareProcedure_SnomedCt?.snomedCode || null;
            element.UrgentAndEmergencyCareProcedure_SnomedCt = element.UrgentAndEmergencyCareProcedure_SnomedCt?.snomedCode || null;
            delete element.date;
            delete element.time;
        }
        const data = {EmergencyCareTreatments_SnomedCt: formattedList};
        props.setData(data);
    };

    // Init Data
    useEffect(() => {
        let data = [];
        if (props.patient?.triage?.treatmentAndManagementPlan) {
            props.patient.triage.treatmentAndManagementPlan.map((code) => {
                if (code.value) {
                    data.push({
                        EmergencyCareProcedure_SnomedCt: code?.value || '-',
                        UrgentAndEmergencyCareProcedure_SnomedCt: code?.value || '-',
                        ProcedureDate_EmergencyCareProcedure: code?.procedureDate || '-',
                        ProcedureTime_EmergencyCareProcedure: code?.procedureTime || '-',
                        CodedProcedureTimestamp_UrgentAndEmergencyCareProcedure: code?.procedureTimestamp || '-',
                        date: getLocalDateText(code, 'date'),
                        time: getLocalDateText(code, 'time'),
                        timestamp: code?.procedureTimestamp || '-',
                    });
                }
            });
            setList([...data]);
        }
    }, []);

    useEffect(() => {
        setDataDictionary();
    }, [list]);

    const getLocalDateText = (obj, type) => {
        const local = UtilsMomentJS.getLocalDateFromUTCECDSFormat(obj.procedureDate, obj.procedureTime);
        if (local) return type === 'date' ? local.format(config.defaultDateFormat) : local.format(config.defaultTimeFormat);
        return '-';
    };

    if (props.accordion !== 'Emergency Care Treatments' && props.accordion !== 'Urgent And Emergency Care Treatments') return null;

    return (
        <div className={classes.root}>
            {!_.isEmpty(list) &&
                <AgyleTable
                    columns={version === 'V3' ? COLUMNS_V3 : COLUMNS_V4}
                    data={list}
                    disableFilter
                />
            }
            {_.isEmpty(list) &&
                <InformationBox type="info">
                    {t('No Treatments Set.')}
                </InformationBox>
            }
        </div>
    );
};

export default Treatments;
